import { Switch } from 'antd';
import FormField from 'components/FormField';
import { noop } from 'lodash-es';
import { useTranslate } from '@tolgee/react';
import { PolicyFormValues, Validate } from './share';
import { DisabledProps } from '../TaskForm/share';

type FV = Pick<PolicyFormValues, 'enable'>;

export const validate: Validate = noop;

function EnableField({ disabled }: DisabledProps) {
  const { t } = useTranslate();

  return (
    <FormField<FV['enable']> required name="enable" label={t('aide.策略开关')}>
      {({ field: { value, onChange } }) => {
        return (
          <Switch
            disabled={disabled}
            checked={value}
            onChange={onChange}
            checkedChildren={t('aide.开')}
            unCheckedChildren={t('aide.关')}
          />
        );
      }}
    </FormField>
  );
}

export default EnableField;
